/**
 *
 * @param {boolean} completed Pass, None-pass 불린 값
 * @returns
 */
export function IsPass({ completed = true, importantComplete = false }) {
  let type = '';
  if (!completed) {
    type = 'red';
  } else {
    type = 'green';
  }

  if (importantComplete) {
    type = 'green';
  }

  return (
    <p
      className={`fw-bold noto-sans fz-16 py-1 px-3 rounded-5 text-nowrap lh-22
    ${type === 'red' && 'isSuccess-red'} 
    ${type === 'green' && 'isSuccess-green'} 
    `}
    >
      {type === 'red' && 'None-pass'}
      {type === 'green' && 'Pass'}
    </p>
  );
}
